module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-11"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65e04b19", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e04b19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminMain.vue
// module id = 119
// module chunks = 0